import React from "react";
import { GlobalContext } from "../../../../utils/globalprovider.js";

import Icon from "../../../../components/bases/icone/icon.js";
import Button from "../../../../components/bases/button/button.js";


import ConfManager from "../../confmanager/confmanager.js";
import MergeDialog from "./mergedialog/mergedialog.js";

import SelectRange from "./submenudialogs/selectrange.js";
import SubtitleColor from "./submenudialogs/subtitlecolor.js";
import SubtitlePosition from "./submenudialogs/subtitleposition.js";
import SubtitleInterval from "./submenudialogs/subtitleinterval.js";
import Offset from "./submenudialogs/offset.js";
import DeleteSubtitles from "./submenudialogs/deletesubtitles.js";
import SearchAndReplaceOption from "./submenudialogs/searchandreplaceoption.js";
import imgmenuclose from "./assets/menuassets/menuclose.png"
import imgmenuopen from "./assets/menuassets/menuopen.png"


import imgconf from "./assets/menuassets/conf.png"
import imgopen from "./assets/menuassets/open.png"
import imgsave from "./assets/menuassets/save.png"


import imgmiscellianous from "./assets/menuassets/miscellianous.png"
import imgmerge from "./assets/menuassets/merge.png"
import imgselectallst from "./assets/menuassets/selectallst.png"
import imgrangest from "./assets/menuassets/rangest.png"
import imgunselectallst from "./assets/menuassets/unselectallst.png"
import imgselectcolor from "./assets/menuassets/selectcolor.png"
import imgdisplay from "./assets/menuassets/display.png"

import imgsearchandreplace from "./assets/menuassets/searchandreplace.png"
import imgdeletesubtitles from "./assets/menuassets/deletesubtitles.png"



import imgplayer from "../../assets/toolsbar/display/player.png"
import imgspeakers from "../../assets/toolsbar/display/speakers.png"
import imgsequences from "../../assets/toolsbar/display/sequences.png"
import imgtimeline from "../../assets/toolsbar/display/timeline.png"
import imgsubtitles from "../../assets/toolsbar/display/soustitres.png"
import imgtranscription from "../../assets/toolsbar/display/transcription.png"

import imgtiming from "./assets/menuassets/timing.png"
import imginterval from "./assets/menuassets/interval.png"
import imgoffset from "./assets/menuassets/offsetglobal.png"

import { configurations_getDefaultParams } from "../../../../utils/configurations.js";

import './optionsmenu.css';
import { secondsToTimecodeWithMilliseconds } from "../utils.js";





class OptionsMenu extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);


        var menu  = [];


        // menu configuration

        // type == "subtitling"


        if (this.props.type === "subtitling")
        {

            const divers = 
            {
                name: {fr:"Divers",en:"Miscellianous"},
                img: imgmiscellianous,
                extend: false,
                key: "miscellianous",
            submenus: [
                {
                    name: {fr:"Concaténer/Fusionner",en:"Merge/Concatenate"},
                    img: imgmerge,
                    key: "merge",
                    highlightable: true,
                    highlight: false,
                    dialog: true,

                },
                {
                    name: {fr:"Suppression de sous-titres",en:"Delete subtitles range"},
                    img: imgdeletesubtitles,
                    key: "delete",
                    highlightable: true,
                    highlight: false,

                },

            ]

            }

            const subtitles = 
            {
                name: {fr:"Sous-titres (Textes)",en:"Subtitles (Texts)"},
                img: imgsubtitles,
                extend: true,
                key: "subtitles",
            submenus: [
                {
                    name: {fr:"Positionnements",en:"Positions"},
                    img: imgselectallst,
                    key: "positionning",
                    highlightable: true,
                    highlight: false,

                },
                {
                    name: {fr:"Couleurs",en:"Colors"},
                    img: imgselectcolor,
                    key: "colors",
                    highlightable: true,
                    highlight: false,

                },
                {
                    name: {fr:"Rechercher un mot",en:"Search a word"},
                    img: imgsearchandreplace,
                    key: "search",
                    highlightable: true,
                    highlight: (this.props.defaultOption === "search"),

                },
                {
                    name: {fr:"Remplacer un mot",en:"Replace a word"},
                    img: imgsearchandreplace,
                    key: "replace",
                    highlightable: true,
                    highlight: (this.props.defaultOption === "replace"),

                },
            ]
            
            }

            const subtitles2 = 
            {
                name: {fr:"Sous-titres (Timecodes)",en:"Subtitles (Timecodes)"},
                img: imgtiming,
                extend: true,
                key: "subtitlestc",
            submenus: [
                {
                    name: {fr:"Correction des intervalles",en:"Interval correction"},
                    img: imginterval,
                    key: "interval",
                    highlightable: true,
                    highlight: false,

                },
                {
                    name: {fr:"Offset",en:"Offset"},
                    img: imgoffset,
                    key: "offset",
                    highlightable: true,
                    highlight: false,

                },
            ]
            
            }

            menu.push (subtitles);    
            menu.push (subtitles2);
            menu.push (divers);


            const selection = 
            {
                name: {fr:"Sélection",en:"Selection"},
                img: imgsubtitles,
                extend: false,
                key: "selection",
                submenus: [
                {
                    name: {fr:"Sélectionner tous les sous-titres",en:"Select all subtitles"},
                    img: imgselectallst,
                    key: "selectallst",
                    highlightable: false,
                    highlight: false,

                },
                {
                    name: {fr:"Plage de sous-titres et attributs",en:"Subtitles range and attributes"},
                    img: imgrangest,
                    key: "selectrange",
                    highlightable: true,
                    highlight: false,

                },
                {
                    name: {fr:"Inverser la seléction",en:"Invert selection"},
                    img: imgrangest,
                    key: "invertselection",
                    highlightable: false,
                    highlight: false,

                },
                {
                    name: {fr:"Désélectionner tous les sous-titres",en:"Unselect all subtitles"},
                    img: imgunselectallst,
                    key: "unselectallst",
                    highlightable: false,
                    highlight: false,

                },
            ]
            

            }

            menu.push (selection);    
        }

        const configuration = 
        {
            name: {fr:"Configurations",en:"Configurations"},
            img: imgconf,
            key: "configurations",
            extend: true,
            submenus: [
                {
                    name: {fr:"Charger une configuration",en:"Load configuration"},
                    img: imgopen,
                    key: "loadconf",
                    highlightable: true,
                    highlight: false,

                },
                {
                    name: {fr:"Sauvegarder une configuration",en:"Save configuration"},
                    img: imgsave,
                    key: "saveconf",
                    highlightable: true,
                    highlight: false,
                }
            ]

        }

        menu.push (configuration);

        // menu display block

        var display = 
        {
            name: {fr:"Zones affichées",en:"Displayed blocks"},
            img: imgdisplay,
            key: "display",
            extend: false,
            submenus: [
                {
                    name: {fr:"Player",en:"Player"},
                    img: imgplayer,
                    key: "displayplayer",
                    highlightable: false,
                    highlight: false,

                },
                {
                    name: {fr:"Timeline",en:"Timeline"},
                    img: imgtimeline,
                    key: "displaytimeline",
                    highlightable: false,
                    highlight: false,

                },
                {
                    name: {fr:"Speakers",en:"Speakers"},
                    img: imgspeakers,
                    key: "displayspeakers",
                    highlightable: false,
                    highlight: false,

                },
                {
                    name: {fr:"Séquences",en:"Sequences"},
                    img: imgsequences,
                    key: "displaysequences",
                    highlightable: false,
                    highlight: false,

                },
                {
                    name: {fr:"Transcription",en:"Transcription"},
                    img: imgtranscription,
                    key: "displaytranscription",
                    highlightable: false,
                    highlight: false,

                },

            ]
        }

        if (this.props.type === "subtitling")
        {
            display.submenus.push (
                {
                    name: {fr:"Sous-titres",en:"Subtitles"},
                    img: imgsubtitles,
                    key: "displaysubtitles",
                    highlightable: false,
                    highlight: false,

                },

            )            
        }

        menu.push (display);

        this.state=
        {
            menu:menu,
            selected: this.props.defaultOption,
            dialog: false,
            displayMergeDialog: false,
        }

        this.onClickOnExtend  = this.onClickOnExtend.bind(this);
        this.onClickOnSubMenu = this.onClickOnSubMenu.bind(this);

        this.gereDialogMergeSvaSubtitlesCallback = this.gereDialogMergeSvaSubtitlesCallback.bind(this);
        this.onClickOnMergeDialog = this.onClickOnMergeDialog.bind(this);

        this.searchAndReplaceOptionRef = React.createRef();
    }

    onClickOnExtend(index)
    {
        
        var menu = this.state.menu;
        menu[index].extend = !menu[index].extend;
        this.setState({menu:menu});

    }

    setCurrentOption(menu,option)
    {
        this.onClickOnSubMenu(menu, option)
    }

    onClickOnSubMenu(keymenu, keysubmenu = "")
    {
        
        var themenu = this.state.menu;
        const indexmenu = themenu.findIndex(menu => menu.key == keymenu);
        if (indexmenu !== -1)
        {
            const thesubmenu = themenu[indexmenu];
            
            const indexsubmenu = thesubmenu.submenus.findIndex(submenu => submenu.key == keysubmenu);
            if (indexsubmenu !== -1)
            {
                

                if (themenu[indexmenu].submenus[indexsubmenu].highlightable)
                {
                    
                    // ici on ouvre le truc correspondant

                    var dialog= false;
                    if (themenu[indexmenu].submenus[indexsubmenu].dialog)
                        dialog=true;


                    this.setState({selected: keysubmenu, dialog: dialog});
                    if (dialog)
                        this.gereDialog (keysubmenu)

                }
                else
                {
                    
                    if (this.props.onaction)
                        this.props.onaction(
                            {
                                source:"submenu",
                                submenu: themenu[indexmenu].submenus[indexsubmenu]
                            }
                    );
                    this.setState({selected: "", dialog:false});
                }


            }

        }
    }

    // ******************************************************************
    // * gestion des dialogues
    // ******************************************************************

    gereDialog (keysubmenu)
    {
        switch (keysubmenu)
        {
            case "merge":
                this.gereDialogMerge();
                break;
        }
    }

    gereDialogMerge()
    {
        
        this.props.saveSubtitles(this.gereDialogMergeSvaSubtitlesCallback)
    }

    gereDialogMergeSvaSubtitlesCallback()
    {
        // ici on peut ouvrir la boite de dialogue de fusionnage
        this.setState ({displayMergeDialog:true});
    }
    onClickOnMergeDialog()
    {
        //
        if ((this.props.mediaassetref) && (this.props.mediaassetref.current))
        {
            console.log("on clickonmergedialog", this.props.mediaassetref)
            this.props.mediaassetref.current.reloadAllAssets();
        }

        this.setState ({displayMergeDialog:false});


    }

    render()
    {

      var addwindows = []
      if (this.state.displayMergeDialog) {
        addwindows.push(<MergeDialog display={this.state.displayMergeDialog} onButton={this.onClickOnMergeDialog} pjid={this.props.pjid}/>)
      }

        

        var allmenu = [];
        this.state.menu.forEach ((menu,index) =>{
            allmenu.push (
                <div className="optionsmenu">
                {menu.extend?(
                    <Button width="12" height="12" image={imgmenuopen} onClick={e=>{this.onClickOnExtend(index)}}/>
                    ):(
                    <Icon width="12" height="12" image={imgmenuclose} onClick={e=>{this.onClickOnExtend(index)}}/>
                    )}
                &nbsp;<Icon width="12" height="12" image={menu.img}/>
                <span className="optionssubmenuunselected" onClick={e=>{this.onClickOnExtend(index)}}>
                &nbsp;{this.context.language == "fr"?menu.name.fr:menu.name.en}
                </span>
                </div>
            )
            if (menu.extend)
            {
                menu.submenus.forEach (submenu =>{
                    var classname="optionssubmenu";
                    var optionssubmenuselected="optionssubmenuunselected";
                    if (this.state.selected === submenu.key)
                        optionssubmenuselected="optionssubmenuselected";

                    allmenu.push (
                    <div className={classname}>
                    <Icon width="12" height="12" image={submenu.img}/>
                    &nbsp;
                    <span className={optionssubmenuselected} onClick={e=>{this.onClickOnSubMenu(menu.key,submenu.key)}}>
                    {this.context.language == "fr"?submenu.name.fr:submenu.name.en}
                    </span>
                    </div>
                    )

                })
            }
            
        })

        if (this.state.selected ==="" || this.state.dialog)
        {
            return (
                <div className="optionsmenudiv">
                    {allmenu}
                    {addwindows}
                </div>
            )
        }
        else
        {


            var submenu = (<></>);

            switch (this.state.selected)
            {

                case "replace":
                case "search":
                    submenu = (
                    <SearchAndReplaceOption
                        ref={this.searchAndReplaceOptionRef}
                        onaction = {this.props.onaction} 
                        subtitles = {this.props.subtitles} 
                        current = {this.props.current}
                        st_list_ref  = {this.props.st_list_ref}
                        st_edit_ref = {this.props.st_edit_ref}
                        showSearch={this.state.selected === "search"}
                        showReplace={this.state.selected === "replace"}
                    />
                    )
                    break;
                case "delete":
                    submenu = (
                    <DeleteSubtitles
                        onaction = {this.props.onaction} subtitles = {this.props.subtitles} current = {this.props.current}
                    />
                    )
                    break;

                case "colors":
                    submenu = (
                    <SubtitleColor
                        onaction = {this.props.onaction} subtitles = {this.props.subtitles} current = {this.props.current}
                    />
                    )
                    break;

                case "offset":
                    submenu = (
                    <Offset
                        onaction = {this.props.onaction} 
                            subtitles = {this.props.subtitles} 
                            current = {this.props.current} 
                            timecode = {this.props.timecode}
                            timecodeasset = {this.props.timecodeasset}
                    />
                    )
                    break;

                    case "positionning":
                    submenu = (
                    <SubtitlePosition
                        onaction = {this.props.onaction} subtitles = {this.props.subtitles} current = {this.props.current}
                    />
                    )
                    break;


                case "interval":
                    submenu = (
                    <SubtitleInterval
                        onaction = {this.props.onaction} 
                        subtitles = {this.props.subtitles} 
                        current = {this.props.current} 
                        stparams = {this.props.stparams}
                    />
                    )
                    break;



                case "selectrange":
                    submenu = (
                    <SelectRange onaction = {this.props.onaction} subtitles = {this.props.subtitles}/>

                    )
                    break;
                case "loadconf":
                    submenu = (
                        <>
                            <ConfManager
                                codatas = {this.props.codatas}
                                stparams = {this.props.stparams}
                                onaction = {this.props.onaction}
                                key = {this.state.selected}
                                action = "load"
                            />
                        </>
                    )
                    break;
                case "saveconf":
                    submenu = (
                        <>
                            <ConfManager
                            
                                codatas = {this.props.codatas}
                                stparams = {this.props.stparams}
                                onaction = {this.props.onaction}
                                key = {this.state.selected}
                                action = "save"
                            />
                        </>
                    )
                    break;
            }

            return (
                <div className="optionsmenudiv2">
                    <div className="optionsmenudiv2a">
                        {allmenu}
                    </div>
                    <div className="optionsmenudiv2b">
                        {submenu}
                    </div>
                </div>
            )

        }
    }


    

}
OptionsMenu.defaultProps = 
{ 
    codatas : {coid: -1},
    stparams: configurations_getDefaultParams(25,1),
    subtitles: [],
    current: 1,
    defaultOption: ""
}

export default OptionsMenu;

